module.exports = __webpack_public_path__ + "static/media/logo-lsss.b3fd5e70.png";